import Control from 'ol/control/Control';
import { olx } from 'openlayers';

export class CustomOlControl extends Control {
  olbutton: HTMLButtonElement;
  private baseClass: string;

  constructor(onClick: (e: any) => void, className: string, options: olx.control.ControlOptions) {
    const button = document.createElement('button');
    const element = document.createElement('div');

    element.appendChild(button);

    options.element = element;

    super(options);

    button.addEventListener('click', (e: any) => onClick(e));
    this.olbutton = button;
    this.baseClass = `bom-ol-control button button-quaternary ${className}`;
    this.setClass(this.baseClass);
  }

  setClass(className: string): void {
    this.olbutton.className = `${this.baseClass} ${className}`;
  }
}
